import { match } from "ts-pattern";
import { ScheduleV2Compat, type DateTimeRecord, type ScheduleV2 } from "@visioni/schedules";
import type { AlarmSchedule } from "./types";
import { mode } from "../schema/alarm-schedule";

export type { Mode } from "../schema/alarm-schedule";

/** Upgrade a V1 schedule to V2, passing V2 schedules through unchanged. */
const toV2 = (schedule: AlarmSchedule | ScheduleV2): ScheduleV2 =>
  match(schedule)
    .with({ schema_version: "1" }, (s) => ScheduleV2Compat.fromV1(s))
    .with({ schema_version: "2" }, (s) => s)
    .exhaustive();

/**
 * Returns the current {@link Mode} of the schedule at {@link at}.
 *
 * When {@link features} is supplied, only those features contribute to the mode
 * (see {@link mode}). Defaults to every feature on the schedule.
 */
export const getMode = (schedule: AlarmSchedule | ScheduleV2, at: DateTimeRecord, features?: readonly string[]) =>
  mode(toV2(schedule), at, features);
